import { useIntl } from 'react-intl';

import { useSalaryWithCap } from '@xing-com/crate-dream-machine-hooks';
import type { JobCardData } from '@xing-com/crate-dream-machine-types';

import { PeakAndPopSalary } from '../../components/peak-and-pop/peak-and-pop-salary';
import { Tile } from '../../components/tile';
import { useDeckCardTyped } from '../../context';

export const getSalary = (
  data: JobCardData
): { maximum: number; currency: string } | null => {
  if (
    (data.salary?.__typename === 'SalaryEstimate' ||
      data.salary?.__typename === 'SalaryRange') &&
    data.salary?.maximum &&
    data.salary.currency
  ) {
    return { maximum: data.salary.maximum, currency: data.salary.currency };
  }
  return null;
};

export const SalaryTile: React.FC = () => {
  const intl = useIntl();
  const { data } = useDeckCardTyped(['TakenJob', 'AvailableJob'] as const);
  const getSalaryWithCap = useSalaryWithCap();
  const salary = data && getSalary(data);

  if (!salary) {
    return null;
  }

  return (
    <Tile
      label={intl.formatMessage({
        id: 'DREAM_MACHINE_JOB_CARD_SALARY_TILE_TITLE',
      })}
      title={getSalaryWithCap(salary.maximum, salary.currency)}
      trackTileName="salary"
      PeakAndPop={PeakAndPopSalary}
    />
  );
};
